module.exports = __webpack_public_path__ + "img/Vestfold - Færder.e37c280b.svg";